// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { buttonStyles } from "@store/Themes/common/mixins/button";
import { buttonGetHoverProps } from "@store/Themes/common/props/button";
import common from "@store/Themes/common/styleguide/components/button";
import { css } from "styled-components";

const button: any = {
    ...common,
    header: {
        shape: "rectangle",
        buttonType: "outline",
        ...buttonGetHoverProps("primary"),
        css: css`
            ${buttonStyles("outline")}
            background-color: transparent;
            color: ${getColor("primary.contrast")};
            border-color: ${getColor("primary")};

            &:hover,
            :focus,
            :active {
                background-color: ${getColor("primary")} !important;
                border-color: ${getColor("primary")} !important;
            }
        `,
    },
};

export default button;
